module.exports = __webpack_public_path__ + "img/busy_answer.fcc3a477.png";